import { createContext } from 'react'

/**
 * Host element of the nearest pharaoh-next scope. Base UI portals (Dialog, Popover…) must render
 * into this element so the `[data-theme]` variables are in scope — outside it the pharaoh-next
 * utilities resolve to nothing and user-agent resets reappear.
 *
 * pharaoh-next owns only the contract: the Provider lives in the app, which needs the active
 * pharaoh v1 theme to build the scope element. `null` means there is no scope host — consumers must
 * then let Base UI fall back to `document.body`, which is what Storybook wants since its theme is
 * applied globally.
 */
export const PortalContainerContext = createContext<HTMLElement | null>(null)
